module.exports = __webpack_public_path__ + "static/media/Convert more leads.e5f557e3.svg";